import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../../../components/partials/PageTitle";
import Select from "../../../../components/form/select/Select";
import {
  getSingleForm,
  resetFormStatus,
  updateCustormForm,
} from "../../../../redux/slice/form/formSlice";
import { BeatLoader } from "react-spinners";

const inputFieldTypes = [
  "text",
  "checkbox",
  "color",
  "date",
  "email",
  "file",
  "image",
  "number",
  "password",
  "radio",
  "range",
  "reset",
  "search",
  "submit",
  "tel",
  "button",
];
const EditForm = () => {
  const { single_form, updateSuccess } = useSelector((state) => state.form);
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const navigate = useNavigate();

  const transformedFields =
    single_form &&
    single_form[0]?.custom_field?.map((field) => ({
      ...field,
      compulsory_field: field.compulsory_field === 1, // Transform 1 to true, 0 to false
    }));

  // const [formFields, setFormFields] = useState([{field_name: '',
  //   field_type: '',
  //   compulsory_field: false,}]);
  const [formFields, setFormFields] = useState(transformedFields);
  const [formName, setFormName] = useState(
    single_form && single_form[0]?.form_name
  );
  const [formNameError, setFormNameError] = useState("");
  const [formFieldsError, setFormFieldsError] = useState("");
  const [editing, setEditing] = useState(false);
  const [hasEditForm, setHasEditForm] = useState(null);

  const { id } = useParams();

  const dispatch = useDispatch();

  const breadcrumb = {
    from: {
      title: "Forms",
      link: "/admin/settings/forms",
    },
    current: {
      title: "Edit Form",
      link: null,
    },
  };

  // Function to add a new field to the form
  const addFormField = () => {
    const newField = {
      field_name: "",
      field_type: inputFieldTypes[0],
      compulsory_field: false,
    };
    setFormFields([...formFields, newField]);
  };

  // Function to remove a field from the form
  const removeFormField = (index) => {
    const updatedFields = [...formFields];
    updatedFields.splice(index, 1);
    setFormFields(updatedFields);
  };

  // Function to handle changes in field name
  const handleFieldNameChange = (index, event) => {
    const updatedFields = [...formFields];
    updatedFields[index].field_name = event.target.value;
    setFormFields(updatedFields);
  };

  // Function to handle changes in field type
  const handleFieldTypeChange = (index, event) => {
    const updatedFields = [...formFields];
    updatedFields[index].field_type = event.value;
    setFormFields(updatedFields);
  };

  // Function to handle changes in compulsory_field
  const handleCompulsoryFieldChange = (index) => {
    const updatedFields = [...formFields];
    updatedFields[index].compulsory_field =
      !updatedFields[index].compulsory_field;
    setFormFields(updatedFields);
  };

  // Function to handle changes in form name
  const handleFormNameChange = (event) => {
    setFormName(event.target.value);
  };

  // Function to validate the form before submission
  const validateForm = () => {
    let isFormValid = true;
    let isFormFieldsValid = true;

    // Validate form name
    if (!formName.trim()) {
      setFormNameError("Form Name is required");
      isFormValid = false;
    } else {
      setFormNameError("");
    }

    // Validate form fields
    formFields.forEach((field, index) => {
      if (!field.field_name.trim()) {
        isFormFieldsValid = false;
      }
    });

    if (!isFormFieldsValid) {
      setFormFieldsError("All Field Names are required");
      isFormValid = false;
    } else {
      setFormFieldsError("");
    }

    return isFormValid;
  };

  const resetFormState = () => {
    if (single_form) {
      const transformedFields =
        single_form[0]?.custom_field?.map((field) => ({
          ...field,
          compulsory_field: field.compulsory_field === 1,
        })) || [];

      setFormFields(transformedFields);
      setFormName(single_form[0]?.form_name);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      dispatch(
        updateCustormForm({
          form_array: formFields,
          form_name: formName,
          id: single_form[0].id,
        })
      );
    }
  };

  useEffect(() => {
    dispatch(getSingleForm(id));
  }, [dispatch, id]);

  useEffect(() => {
    resetFormState();
  }, [single_form]);

  useEffect(() => {
    if (updateSuccess) {
      dispatch(getSingleForm(id));
      resetFormState();
      setEditing(false);
      dispatch(resetFormStatus());
    }
  }, [dispatch, id, resetFormState, updateSuccess]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "custom form module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "view custom form"
      )
    ) {
      navigate("/admin/dashboard");
    }

    setHasEditForm(
      user_permissions?.some(
        (permission) => permission.name === "update custom form"
      )
    );
  }, [navigate, user_permissions]);

  if (!single_form) {
    return (
      <div className='mt-2'>
        <BeatLoader
          height='80'
          width='80'
          radius='9'
          color='#2e3192'
          ariaLabel='three-dots-loading'
          wrapperStyle={{}}
          wrapperClassName=''
          visible={true}
        />
      </div>
    );
  }

  return (
    <div>
      {/* page title */}
      <PageTitle title='Edit Custom Form' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card '>
            <form onSubmit={onSubmit}>
              <div className='row p-3'>
                <div className='mb-0 col-md-12'>
                  <label htmlFor='inputEmail4' className='form-label'>
                    Form Name <span className='text-danger'>*</span>
                  </label>
                  {editing ? (
                    <div>
                      <input
                        textname='form name'
                        name='office_name'
                        onChange={handleFormNameChange}
                        value={formName}
                        type='text'
                        className={`form-control form-control-sm mb-2`}
                        placeholder='Form Name'
                      />
                      {formNameError && (
                        <span className='text-danger'>{formNameError}</span>
                      )}
                    </div>
                  ) : (
                    <p className='form-control border-0 shadow'>{formName}</p>
                  )}
                </div>
                <div className='col-md-12 row mt-3'>
                  <div className={editing ? "col-md-10" : `col-md-12`}>
                    {formFields?.map((field, index) => (
                      <div className='mb-1' key={index}>
                        <div key={index} className=' row'>
                          <div className={editing ? "col-md-5" : "col-md-6"}>
                            <label htmlFor='inputEmail4' className='form-label'>
                              Field Name
                            </label>
                            {editing ? (
                              <input
                                type='text'
                                placeholder='Field Name'
                                value={field.field_name}
                                className={`form-control form-control-sm`}
                                onChange={(e) =>
                                  handleFieldNameChange(index, e)
                                }
                              />
                            ) : (
                              <p className='form-control border-0 shadow'>
                                {field.field_name}
                              </p>
                            )}
                          </div>
                          <div className={editing ? "col-md-5" : "col-md-6"}>
                            <label htmlFor='inputEmail4' className='form-label'>
                              Field Type
                            </label>
                            {editing ? (
                              <Select
                                data={inputFieldTypes?.map((item) => {
                                  return {
                                    label: item,
                                    value: item,
                                  };
                                })}
                                value={field.field_type || ""}
                                onChange={(e) =>
                                  handleFieldTypeChange(index, e)
                                }
                              />
                            ) : (
                              <p className='form-control border-0 shadow'>
                                {field.field_type}
                              </p>
                            )}
                          </div>
                          {formFields.length > 1 && editing && (
                            <div className='col-md-1 mt-3 '>
                              <label
                                htmlFor='inputEmail4'
                                className='form-label'
                              ></label>
                              <span
                                className=''
                                onClick={() => removeFormField(index)}
                              >
                                <i className='mdi mdi-delete text-danger fs-4 mdi-cursor-pointer'></i>
                              </span>
                            </div>
                          )}
                        </div>
                        <div className='d-flex items-center gap-1 mt-1'>
                          <input
                            className={`form-check-input`}
                            type='checkbox'
                            checked={field.compulsory_field}
                            onChange={() => handleCompulsoryFieldChange(index)}
                            style={{ height: "20px", width: "20px" }}
                            disabled={!editing}
                          />
                          <label>
                            <p>Compulsory Field</p>
                          </label>
                        </div>
                        {index === formFields.length - 1 && formFieldsError && (
                          <div className='mb-0 text-danger'>
                            {formFieldsError}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  {editing && (
                    <div className='col-md-2'>
                      <label htmlFor=''></label>
                      <button
                        type='button'
                        className='btn btn-primary btn-sm px-4 rounded d-flex justify-content-center align-items-center gap-1'
                        onClick={addFormField}
                      >
                        <i className='mdi mdi-plus'></i>
                        <span>Add</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className='d-flex gap-2 mt-3'>
                  {!editing && hasEditForm && (
                    <button
                      onClick={() => setEditing(true)}
                      className='btn btn-primary btn-sm px-4 rounded'
                    >
                      <span>Edit</span>
                    </button>
                  )}
                  {editing && (
                    <div className='d-flex gap-2'>
                      <button
                        onClick={() => {
                          setEditing(false);
                          resetFormState();
                        }}
                        className='btn btn-secondary btn-sm px-4 rounded'
                      >
                        <span>Cancel</span>
                      </button>
                      <button
                        type='submit'
                        className='btn btn-primary btn-sm px-4 rounded'
                      >
                        <span>Submit</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditForm;
